// Self-managed token storage. The pair comes from the backend auth-api
// (magic-link verify / Apple / refresh).
import type { TokenPair } from "@/types";

const ACCESS_KEY = "a8.accessToken";
const REFRESH_KEY = "a8.refreshToken";
// Absolute epoch-ms expiry of the access token, derived from the pair's
// `expiresIn` at store time. Kept so we can refresh PROACTIVELY (before a call or
// a WebSocket handshake fails) instead of only reacting to a rejection.
const EXPIRES_AT_KEY = "a8.accessExpiresAt";

const MILLIS_PER_SECOND = 1000;

export const tokenStore = {
  get(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  /** Absolute epoch-ms when the access token expires, or null if unknown. */
  getExpiresAt(): number | null {
    const raw = localStorage.getItem(EXPIRES_AT_KEY);
    const parsed = raw ? Number(raw) : NaN;
    return Number.isFinite(parsed) ? parsed : null;
  },
  setPair(pair: TokenPair): void {
    localStorage.setItem(ACCESS_KEY, pair.accessToken);
    localStorage.setItem(REFRESH_KEY, pair.refreshToken);
    localStorage.setItem(
      EXPIRES_AT_KEY,
      String(Date.now() + pair.expiresIn * MILLIS_PER_SECOND),
    );
  },
  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(EXPIRES_AT_KEY);
  },
};
